// extracted by mini-css-extract-plugin
var _1 = "styles-module__container___IV8Cy";
var _2 = "styles-module__handle___WrKwV";
var _3 = "styles-module__image___YuKSK";
var _4 = "styles-module__imageContainer___yr4zN";
var _5 = "styles-module__title___r4cwi";
export { _1 as "container", _2 as "handle", _3 as "image", _4 as "imageContainer", _5 as "title" }
